import { useMutation, useQueryClient } from 'react-query';
import { API } from '../../../../utils/ApiClient';

function useDeleteLanguage() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id }: { id?: string }) => API.delete('/languages/' + id),
        onSuccess() {
            queryClient.invalidateQueries('languages');
        },
    });
}

export default useDeleteLanguage;
